/*
 * Calculator interface strings, English.
 *
 * The "calc" bucket: the calculator's own chrome, the worksheet cards, the
 * saved-results panel, and the messages about a number that could not be read
 * or that an old result was computed from. English and Spanish only; another
 * interface language falls back to English, or to Spanish when the reader's
 * browser is Spanish (i18n/index.jsx).
 */

const strings = {
  "calc.minimiseTitle": "Minimise calculator (back to Gia)",
  "calc.minimiseLabel": "Minimise calculator, back to Gia",
  "saved.title": "Saved calculations",
  "saved.staleSummary": "⚠ {count} of these was calculated with a method that has since been corrected.",
  "saved.staleSummary_one": "⚠ {count} of these was calculated with a method that has since been corrected.",
  "saved.staleSummary_other": "⚠ {count} of these were calculated with a method that has since been corrected.",
  "saved.staleAction": "Re-run it in the calculator before relying on the figure. Gia will not quote superseded results.",
  "saved.staleAction_one": "Re-run it in the calculator before relying on the figure. Gia will not quote superseded results.",
  "saved.staleAction_other": "Re-run them in the calculator before relying on the figures. Gia will not quote superseded results.",
  "saved.none": "None yet. Open the calculator from Tools, run one, and click Save to project.",
  "saved.revision": "Revision",
  "saved.superseded": "Superseded",
  "saved.delete": "Delete this saved calculation",
  "saved.methodChanged": "⚠ Method has changed since this was saved.",
  "saved.rerunBefore": "Re-run before relying on the figures below.",
  "saved.revises": "Revises the {name} saved {ts}. That entry is kept below, unchanged.",
  "saved.result": "result",
  "saved.supersededBy": "Superseded by a revision saved {ts}. These figures are still correct for the inputs shown, but are no longer the current intent.",
  "saved.check": "(check)",
  "saved.editTitle": "Load these inputs into the calculator to change one and recalculate",
  "saved.editDisabledTitle": "This result predates input tracking — re-enter the values to recalculate.",
  "saved.edit": "Edit",
  "saved.predates": "Predates input tracking — re-enter the values to recalculate.",
  "calc.choose": "Choose a calculator",
  "calc.tabCalculator": "Calculator",
  "calc.tabWorksheet": "Worksheet",
  "calc.calculate": "Calculate",
  "calc.method": "Method",
  "calc.noProjectRun": "No project (run only)",
  "calc.noProjectsYet": "No projects yet",
  "calc.projectN": "Project {id}",
  "calc.clearAll": "Clear all",
  "calc.emptyTitle": "No calculations yet.",
  "calc.emptyBody": "Run one and it stacks here with its method, so you can build and cite a whole system design.",
  "calc.methodChanged": "⚠ Method has changed since this was calculated.",
  "calc.rerunBefore": "Re-run before relying on this result.",
  "calc.check": "(check)",
  "calc.rerun": "Re-run",
  "calc.saved": "Saved to project ✓",
  "calc.save": "Save to project",
  "calc.sendToGia": "Send to Gia",
  "calc.remove": "Remove",
  "calc.toast.gone": "That calculator no longer exists.",
  "calc.toast.loaded": "Loaded. Change a value and press Calculate — saving adds a new entry and keeps the original.",
  "calc.toast.predates": "This result predates input tracking — re-enter the values to recalculate.",
  "calc.toast.inputsLoaded": "Inputs loaded. Press Calculate to recompute under the current method.",
  "calc.toast.noProject": "No project selected. Create or pick a project first.",
  "calc.toast.savedTo": "Saved to {name}.",
  "calc.toast.savedToProject": "Saved to project.",
  "calc.toast.writeFailed": "Could not write to localStorage.",
  "calc.toast.sent": "Sent to Gia.",
  "calc.misreadNumber": "⚠ A typed number in this result may have been misread.",
  "saved.misreadNumber": "⚠ A typed number in this result may have been misread.",
  "calc.misreadNote": "Saved before a fix to how typed numbers are read ({values}). If you meant thousands, the figures here are wrong. Re-run with the value typed without the point, for example 5000.",
  "calc.ambiguousNumber": "{label}: \"{typed}\" could mean {a} or {b}. Type {a} or {b} instead.",
};

export default strings;
